import React, { useState } from "react";
import { motion } from "framer-motion";
import droneImg from "../../assets/DroneWeb.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-r from-white to-sky-50">
      {/* Hero Section */}
      <main className="flex flex-col md:flex-row items-center justify-between flex-1 px-10 md:px-20 py-10">
        {/* Left Content */}
        <motion.div
          className="max-w-xl space-y-6"
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="font-arya text-4xl md:text-5xl font-medium leading-snug text-gray-800">
            {t("heroSection.heading")}
          </h1>
          <p className="text-gray-600 text-lg">{t("heroSection.description")}</p>
          {/* <div className="flex justify-center items-center md:justify-start">
            <button
              className="border border-gray-400 px-6 py-3 rounded-md text-[#2E6243] font-medium hover:bg-gray-100 transition"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => navigate("/signup")}
            >
              {isHovered ? "LETS GET STARTED" : t("heroSection.clientOnboarding")}
            </button>
            <button
              className="border border-gray-400 px-6 py-3 ml-3 rounded-md text-[#2E6243] font-medium hover:bg-gray-100 transition"
              // onMouseEnter={() => setIsHovered(true)}
              // onMouseLeave={() => setIsHovered(false)}
              onClick={() => navigate("/signup/contractor")}
            >
              Contractor Onboarding
            </button>
          </div> */}
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="mt-10 md:mt-0"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img src={droneImg} alt="Drone" className="w-[700px] h-auto drop-shadow-xl" />
        </motion.div>
      </main>

      {/* Footer Scroll */}
      {/* <div className="absolute bottom-2 left-16 text-left text-gray-500 flex items-center gap-2">
        <img src={scrollIcon} alt="Scroll Icon" className="w-5 h-8" />
        <p>Scroll for more</p>
      </div> */}
    </div>
  );
};

export default HeroSection;
